import script from "./FeaturedResourceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedResourceCard.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturedResourceCard.vue?vue&type=style&index=0&id=c4805b32&lang=scss"

const __exports__ = script;

export default __exports__